import { useRef } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactCard from '../components/ContactCard';

// Correct cover image imports
import Img1 from '../assets/blogs/How to Build a High-Converting Website in 2024-1.jpg';
import Img2 from '../assets/blogs/The Power of Paid Ads-1.jpg';
import Img3 from '../assets/blogs/SEO in 2024-1.jpg';
import Img4 from '../assets/blogs/Why Your Business Needs a Mobile App in 2024-1.jpg';
import Img5 from '../assets/blogs/How to Turn Your Website into a Lead-Gen Machine-1.jpg';
import Img6 from '../assets/blogs/How to Rank on Google Without Spending a Dollar-1.jpg';
import Img7 from '../assets/blogs/How to Get More Clients with Performance Marketing-1.jpg';
import Img8 from '../assets/blogs/Top Web Development Trends to Watch-1.jpg';
import Img9 from '../assets/blogs/Boost Your Brand with Creative Content-1.jpg';
import Img10 from '../assets/blogs/Understanding Meta Pixel...-1.jpg'; // Make sure this file exists as-is or rename it to remove "..."

const posts = [
  {
    title: 'Why Your Business Website Is Costing You Customers (And How to Fix It)',
    excerpt: 'Learn common website mistakes that hurt conversions and what to do about them.',
    slug: 'why-your-business-website-is-costing-you-customers',
    image: Img1,
  },
  {
    title: 'Google Ads vs Facebook Ads: Which One Is Right for Your Business?',
    excerpt: 'PPC platforms compared. Find the best fit for your goals, budget, and audience.',
    slug: 'google-ads-vs-facebook-ads',
    image: Img2,
  },
  {
    title: '7 Signs Your SEO Strategy Needs an Upgrade',
    excerpt: "Is your SEO underperforming? These signs say it's time for a tune-up.",
    slug: '7-signs-your-seo-strategy-needs-an-upgrade',
    image: Img3,
  },
  {
    title: 'The Power of Full-Stack Development for Growing Businesses',
    excerpt: 'See how unified dev teams help SMBs scale faster and build smarter.',
    slug: 'power-of-full-stack-development',
    image: Img4,
  },
  {
    title: 'Content That Converts: The Secret to Successful Digital Marketing',
    excerpt: 'How strong content builds trust, drives traffic, and fuels lead gen.',
    slug: 'content-that-converts',
    image: Img5,
  },
  {
    title: "Lead Generation in 2025: What's Working Now for B2B Businesses",
    excerpt: 'Get ahead with the latest B2B lead generation tactics and tools.',
    slug: 'lead-generation-in-2025',
    image: Img6,
  },
  {
    title: 'Top 5 Reasons Your Mobile App Is Losing Users (And How to Fix It)',
    excerpt: 'UX flaws and engagement killers — and how to reverse the trend.',
    slug: 'why-your-mobile-app-is-losing-users',
    image: Img7,
  },
  {
    title: 'How We Build High-Converting Websites: Our Proven 5-Step Process',
    excerpt: 'Our agency’s framework for sites that look great and sell better.',
    slug: 'how-we-build-high-converting-websites',
    image: Img8,
  },
  {
    title: 'Stop Wasting Ad Spend: How to Optimize PPC for Real Results',
    excerpt: 'Avoid common paid ad mistakes and get more return for your budget.',
    slug: 'how-to-optimize-ppc-for-results',
    image: Img9,
  },
  {
    title: 'Why Every Growing Business Needs a Custom Software Solution',
    excerpt: 'Off-the-shelf tools don’t scale. Here’s what to do instead.',
    slug: 'why-you-need-custom-software',
    image: Img10,
  },
];

export default function Blog() {
  const contactRef = useRef(null);

  const handleTalkClick = () => {
    contactRef.current?.focusForm?.();
  };

  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-br from-white via-sky-50 to-indigo-100 font-sans text-slate-900">
      <Navbar onTalkClick={handleTalkClick} />

      <main className="flex-1 pt-32">
        <section className="mx-auto max-w-4xl px-6 text-center">
          <p className="text-sm uppercase tracking-[0.2em] text-slate-500">Insights for ambitious teams</p>
          <h1 className="mt-4 text-4xl font-semibold md:text-5xl">Digital growth playbooks & ideas</h1>
          <p className="mt-4 text-lg text-slate-600">
            Playbooks, breakdowns, and ideas straight from the campaigns we run every day. Skim a post, share with your
            team, and use it to fuel your next sprint.
          </p>
        </section>

        <section className="mx-auto mt-16 max-w-6xl px-6 pb-12">
          <div className="grid gap-8 md:grid-cols-2 xl:grid-cols-3">
            {posts.map((post) => (
              <article
                key={post.slug}
                className="flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white/70 shadow-sm backdrop-blur transition hover:-translate-y-1 hover:shadow-lg"
              >
                <img src={post.image} alt={post.title} className="h-48 w-full object-cover" />
                <div className="flex flex-1 flex-col p-6">
                  <h2 className="text-xl font-semibold text-slate-900">{post.title}</h2>
                  <p className="mt-3 flex-1 text-sm text-slate-600">{post.excerpt}</p>
                  <Link
                    to={`/blog/${post.slug}`}
                    className="mt-6 inline-flex items-center text-sm font-semibold text-blue-600 transition hover:text-blue-700"
                  >
                    Read the article →
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>

      <ContactCard ref={contactRef} />
      <Footer />
    </div>
  );
}
